import Styles from './QuizInstructions.module.scss';
import { useNavigate, useParams } from 'react-router-dom';

// Component import.
import { InstructionCard } from 'components/global/InstructionCard/InstructionCard';

export function QuizInstructions(props) {
    const { lab_id } = useParams();

    const quizInstructions =
        props.t('Labs.QuizInstructions.instructions', { returnObjects: true });

    const navigate = useNavigate();

    const handleStartClick = () => {
        navigate(`/labs/${lab_id}/quiz/attempt`);
    }

    const handleBackClick = () => {
        navigate(-1);
    }

    return (
        <div id='CardContainer' className={Styles.CardContainer}>
            <InstructionCard
                instructions={quizInstructions}
                handleStartClick={handleStartClick}
                handleBackClick={handleBackClick}
            />
        </div>
    )
}